import { render, staticRenderFns } from "./TextEditor.vue?vue&type=template&id=5ac1409a&"
import script from "./TextEditor.vue?vue&type=script&lang=ts&"
export * from "./TextEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports